export default __webpack_public_path__ + "static/media/00.8b71b9b3.jpg";